import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Navbar from "../../Components/Navbar";
import { toast } from "react-toastify";
import {
  Bg,
  BoxContainer,
  Underline,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
// import EditNotificationModel from "../../Components/Notifications/EditNotificationModel";
import { useLocation, useParams } from "react-router-dom";
import Tables from "../../Components/Notifications/Tables";
import { FaTruckFieldUn } from "react-icons/fa6";
import { use } from "react";

const Notifications = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const { id: propId } = useParams();
  const { t } = useTranslation();
  const location = useLocation();

  const [toggleState, setToggleState] = useState();
  //settings/list/${selectedPropertyId}

  const fetchFunction = async () => {
    const response = await axios.get(`${Config.apiUrl}/settings/list/${propId}`, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.data === false) error = true;
    setToggleState(res?.data);
    // else setApiData(res?.data?.list);
  };

  const getError = (res) => { };

  const {
    isLoading: isLoading,
    mutate: getListMutate,
    error,
    data: notificationData,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    getListMutate();
  }, []);

  // ------- Edit Single Entry -------
  const editNotificationApi = async (data) => {
    return await axios.post(`${Config.apiUrl}/settings/edit`, 
      data, {
      headers: {
        authorization: "Bearer" + " " + user.token,
       // "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onEditNotificationSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      //getNotificationsMutate();
      //setApiData(data.data);
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }

  };

  const onEditNotificationError = (data) => {
    toast.error(data?.data?.msg || "An Error Occured");
  };

  const { isLoading: editEntryLoading, mutate: editNotificationMutate } =
    useMutation(editNotificationApi, {
      onSuccess: onEditNotificationSuccess,
      onError: onEditNotificationError,
    });

  // const handleToggle = (notificationType, currentValue) => {
  //   const formData = {
  //     propId: propId || 0,
  //     type: notificationType,
  //     isEnabled: currentValue ? 0 : 1,
  //   };
  //   editNotificationMutate(formData);
  // };

  const handleToggle = (id) => {
    //setToggleState((prevState) => ({ ...prevState, [id]: !prevState[id] }));
    const formData = {
      propId: Number(propId) || 0,
      type: id,
      isEnabled: Number(!toggleState[id]),
    };
    editNotificationMutate(formData);
    setToggleState((prevState) => ({ ...prevState, [id]: !prevState[id] }));
  };

  return (
    <>
      <BoxContainer>
        <div className="flex w-full justify-between items-center">
          <div>
            <Title>
              {t("Notifications")}
              <span>/{location?.state?.name}</span>
            </Title>
            <Underline />
          </div>
        </div>


        {!error && !isLoading && notificationData && (
          <Wrapper>
            {editEntryLoading ? (
              <div className="w-full h-full">
                <Loading />
              </div>
            ) : (
              <>
                {/* WhatsApp Notification */}
                <OptionGroup>
                  <OptionHeader>
                    <OptionTitle>WhatsApp Notifications</OptionTitle>
                    <ToggleWrapper>
                      <label className="inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          checked={toggleState.whatsApp}
                          onChange={() => handleToggle("whatsApp")}
                          className="sr-only peer"
                        />
                        <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                      </label>
                    </ToggleWrapper>
                  </OptionHeader>
                  <OptionDescription>
                    Enable this to receive important updates and notifications through
                    WhatsApp messages.
                  </OptionDescription>
                </OptionGroup>

                {/* SMS Notification */}
                <OptionGroup>
                  <OptionHeader>
                    <OptionTitle>SMS Notifications</OptionTitle>
                    <ToggleWrapper>
                      <label className="inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          checked={toggleState.sms}
                          onChange={() => handleToggle("sms", true)}
                          className="sr-only peer"
                        />
                        <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                      </label>
                    </ToggleWrapper>
                  </OptionHeader>
                  <OptionDescription>
                    Enable this to receive important updates and notifications through
                    SMS.
                  </OptionDescription>
                </OptionGroup>

                {/* Rent Reminder */}
                <OptionGroup>
                  <OptionHeader>
                    <OptionTitle>Rent Reminder</OptionTitle>
                    <ToggleWrapper>
                      <label className="inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          checked={toggleState.rentReminder}
                          onChange={() => handleToggle("rentReminder", true)}
                          className="sr-only peer"
                        />
                        <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                      </label>
                    </ToggleWrapper>
                  </OptionHeader>
                  <OptionDescription>
                    Enable this to receive important reminders for rent payments.
                  </OptionDescription>
                </OptionGroup>

                {/* Onboard Welcome */}
                <OptionGroup>
                  <OptionHeader>
                    <OptionTitle>Onboard Welcome</OptionTitle>
                    <ToggleWrapper>
                      <label className="inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          checked={toggleState.onboardWelcome}
                          onChange={() => handleToggle("onboardWelcome", true)}
                          className="sr-only peer"
                        />
                        <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                      </label>
                    </ToggleWrapper>
                  </OptionHeader>
                  <OptionDescription>
                    Enable this to receive a welcome message upon onboarding.
                  </OptionDescription>
                </OptionGroup>

                {/* Partial Payment */}
                <OptionGroup>
                  <OptionHeader>
                    <OptionTitle>Partial Payment</OptionTitle>
                    <ToggleWrapper>
                      <label className="inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          checked={toggleState.partialPayment}
                          onChange={() => handleToggle("partialPayment", true)}
                          className="sr-only peer"
                        />
                        <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                      </label>
                    </ToggleWrapper>
                  </OptionHeader>
                  <OptionDescription>
                    Enable this to receive notifications for partial payments.
                  </OptionDescription>
                </OptionGroup>

                {/* Online Payment */}
                <OptionGroup>
                  <OptionHeader>
                    <OptionTitle>Online Payment</OptionTitle>
                    <ToggleWrapper>
                      <label className="inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          checked={toggleState.onlinePayment}
                          onChange={() => handleToggle("onlinePayment", true)}
                          className="sr-only peer"
                        />
                        <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                      </label>
                    </ToggleWrapper>
                  </OptionHeader>
                  <OptionDescription>
                    Enable this to receive notifications about online payments.
                  </OptionDescription>
                </OptionGroup>
              </>
            )}
          </Wrapper>
        )}

        {(isLoading || isRefetching) && <Loading />}
      </BoxContainer>
    </>
  );
};

const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;
const Wrapper = tw.div`pt-1 space-y-6 bg-white mt-8`;
const OptionGroup = tw.div`border-b last:border-b-0 pb-4 mb-4`;
const OptionHeader = tw.div`flex justify-between items-center`;
const OptionTitle = tw.h3`text-gray-700 font-medium`;
const ToggleWrapper = tw.div`flex items-center space-x-4`;
const OptionDescription = tw.p`text-gray-500 text-sm mt-1`;

export default Notifications;
